import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default function initTestimonials() {
    const swiperEl = document.querySelector('.testimonials-swiper');

    if (!swiperEl) return;

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    const canLoop = slideCount > Math.ceil(swiperEl.offsetWidth / 328) + 1;

    const swiper = new Swiper(swiperEl, {
        modules: [Navigation],
        loop: canLoop,
        spaceBetween: 28,
        slidesPerView: 'auto',
        slidesOffsetBefore: 20,
        slidesOffsetAfter: canLoop ? 0 : 20,
        centerInsufficientSlides: true,
        speed: 500,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // Truncate descriptions to 90 characters
    const testimonialTexts = document.querySelectorAll('.js-testimonial-text');
    testimonialTexts.forEach(textEl => {
        const fullText = textEl.textContent.trim();
        const moreEl = textEl.nextElementSibling;

        if (fullText.length > 90) {
            textEl.textContent = fullText.substring(0, 90);
            if (moreEl) moreEl.style.display = 'inline';
        } else {
            if (moreEl) moreEl.style.display = 'none';
        }
    });
}
